export enum PremiaChannel {
  APP = 'CTRLCLIENT',
  PORTAL = 'CTRLBROKER',
}
